export default {
  state: {
    subjectType: [],
    subjectBankId: Number,
    trainType: [],
    timeType: [],
    studyProgress: [{ id: 0, name: '未开始' }, { id: 1, name: '培训中' }, { id: 2, name: '待考试' }, { id: 3, name: '待确认成绩' }, { id: 4, name: '通过培训' }, { id: 5, name: '未通过培训' }, { id: 6, name: '考试过期' }],
    subjectList: []
  },
  getters: {
    subjectType: state => state.subjectType,
    subjectBankId: state => state.subjectBankId,
    trainType: state => state.trainType,
    timeType: state => state.timeType,
    studyProgress: state => state.studyProgress,
    subjectList: state => state.subjectList
  },
  mutations: {
    subjectType (state, data) {
      state.subjectType = data
    },
    subjectBankId (state, data) {
      state.subjectBankId = data
    },
    trainType (state, data) {
      state.trainType = data
    },
    timeType (state, data) {
      state.timeType = data
    },
    subjectList (state, data) {
      state.subjectList = data
    }
  },
  actions: {
    handleSubjectType (subjectType, data) {
      subjectType.commit('subjectType', data)
    },
    handleSubjectBankId (subjectBankId, data) {
      subjectBankId.commit('subjectBankId', data)
    },
    handleTrainType (trainType, data) {
      trainType.commit('trainType', data)
    },
    handleTimeType (timeType, data) {
      timeType.commit('timeType', data)
    },
    handleSubjectList (subjectList, data) {
      subjectList.commit('subjectList', data)
    }
  }
}
